import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from 'shared/config/model/urls';

import {IWebhook, IWebhookAdd, IWebhookEdit} from '../model/INotifyChannel';

import {notifyChannelApiOptions, notifyChannelEndpoints} from './notifyChannelEndpoints';

export const webhookAPI = createApi({
    reducerPath: 'webhookAPI',
    baseQuery: httpBaseQuery(),
    ...notifyChannelApiOptions,
    endpoints: notifyChannelEndpoints<IWebhook, IWebhookAdd, IWebhookEdit>({
        list: ApiUrls.WEBHOOKS,
        item: ApiUrls.WEBHOOK,
        testNotify: ApiUrls.WEBHOOK_TEST_NOTIFY,
    }),
});
